import { useEffect } from "react";
import { usePhaseTimerContext } from "@/contexts/PhaseTimerContext";

/**
 * Passive phase timer hook. Starts timing when mounted (or when phaseCategory changes),
 * automatically switches the timer, and never blocks the user.
 *
 * Pass `phaseCategory = null` to pause tracking (e.g. when no phase is active yet).
 */
export function usePhaseTimer(params: {
  phaseCategory: string | null | undefined;
  phaseLabel?: string;
  applianceId?: string | null;
  applianceType?: string | null;
  brand?: string | null;
  enabled?: boolean;
}) {
  const { startPhase } = usePhaseTimerContext();
  const { phaseCategory, phaseLabel, applianceId, applianceType, brand, enabled = true } = params;

  useEffect(() => {
    if (!enabled || !phaseCategory) return;
    startPhase({
      phaseCategory,
      phaseLabel: phaseLabel || phaseCategory,
      applianceId,
      applianceType,
      brand,
    });
  }, [enabled, phaseCategory, phaseLabel, applianceId, applianceType, brand, startPhase]);
}
